/* eslint-disable no-undef */
<template>
    <div>
        <div id="Dashboard" class="container is-fluid">
            <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />

            <!-- Modal upload dialog box -->
            <div id="modal_pricing_action" class="modal">
                <div class="modal-background"></div>
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Approve User Pricing Action</p>
                        <button
                            class="delete"
                            aria-label="close"
                            @click="close_modal_pricing_action"
                        ></button>
                    </header>
                    <section class="modal-card-body">
                        <form id="pricing_action_form">
                            <fieldset disabled>
                                <div
                                    style="
                                        display: flex;
                                        flex-direction: row;
                                        justify-content: space-between;
                                    "
                                >
                                    <div class="field" style="flex-grow: 1; margin-right: 1em">
                                        <label class="label is-small">Part</label>
                                        <div class="control is-expanded">
                                            <input
                                                v-model="pa_part_number"
                                                class="input is-small"
                                                name="part_number"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                    <div class="field" style="flex-grow: 1">
                                        <label class="label is-small">Customer</label>
                                        <div class="control is-expanded">
                                            <input
                                                v-model="pa_customer"
                                                class="input is-small"
                                                name="customer"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div
                                    style="
                                        display: flex;
                                        flex-direction: row;
                                        justify-content: space-between;
                                    "
                                >
                                    <div class="field" style="flex-grow: 1; margin-bottom: 1em">
                                        <label class="label is-small"
                                            >Suggested Action Description</label
                                        >
                                        <div class="control is-expanded">
                                            <textarea
                                                v-model="pa_description"
                                                class="textarea"
                                                name="result_rule"
                                                type="text"
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    style="
                                        display: flex;
                                        flex-direction: row;
                                        justify-content: space-between;
                                    "
                                >
                                    <div class="field" style="flex-grow: 1; margin-right: 1em">
                                        <label class="label is-small">User Quote</label>
                                        <div class="control">
                                            <input
                                                v-model="pa_user_quote"
                                                class="input is-small"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                    <div class="field" style="flex-grow: 1">
                                        <label class="label is-small">Sug. Quote</label>
                                        <div class="control">
                                            <input
                                                v-model="pa_suggested_quote"
                                                class="input is-small"
                                                name="last_quote_price"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div
                                    style="
                                        display: flex;
                                        flex-direction: row;
                                        justify-content: space-between;
                                    "
                                >
                                    <div class="field" style="flex-grow: 1; margin-right: 1em">
                                        <label class="label is-small">User Margin</label>
                                        <div class="control">
                                            <input
                                                v-model="pa_user_margin"
                                                class="input is-small"
                                                name="last_sale_date"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                    <div class="field" style="flex-grow: 1">
                                        <label class="label is-small">Sug. Margin</label>
                                        <div class="control">
                                            <input
                                                v-model="pa_suggested_margin"
                                                class="input is-small"
                                                name="last_sale_price"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <hr />

                            <div class="field">
                                <label class="label">Approval Notes</label>
                                <div class="control">
                                    <textarea
                                        v-model="pa_approval_note"
                                        class="textarea"
                                        name="result_rule"
                                        type="text"
                                        placeholder="Notes on approval/disapproval reasoning..."
                                    >
                                    </textarea>
                                </div>
                            </div>
                        </form>
                    </section>
                    <footer class="modal-card-foot">
                        <div class="buttons is-right" style="width: 100%">
                            <button class="button" @click="close_modal_pricing_action">
                                Cancel
                            </button>
                            <button
                                class="button is-danger"
                                @click="modal_pricing_action_approval_change(false)"
                            >
                                Disapprove
                            </button>
                            <button
                                class="button is-success"
                                @click="modal_pricing_action_approval_change(true)"
                            >
                                Approve
                            </button>
                        </div>
                    </footer>
                </div>
                <button class="modal-close is-large" @click="close_modal_pricing_action"></button>
            </div>

            <!-- Header -->
            <HeroContainer title="Pricing Analysis Dashboard" />

            <section id="filters" class="filters-section">
                <div class="card shadow-sm filters-card">
                    <div class="card-body filters-body">
                        <div class="field-row">
                            <div class="field">
                                <input
                                    id="switch_pa"
                                    type="checkbox"
                                    name="switch_pa"
                                    class="switch is-rounded is-info"
                                    checked="checked"
                                    v-model="has_pricing_action"
                                />
                                <label
                                    v-if="has_pricing_action"
                                    for="switch_pa"
                                    style="outline: none"
                                    >Price Actions</label
                                >
                                <label v-else for="switch_pa" style="outline: none"
                                    >All Parts</label
                                >
                            </div>

                            <div class="field">
                                <input
                                    id="switch_criteria"
                                    type="checkbox"
                                    name="switch_criteria"
                                    class="switch is-rounded is-info"
                                    checked="checked"
                                    v-model="criteria_ignored"
                                />
                                <label
                                    v-if="criteria_ignored"
                                    for="switch_criteria"
                                    style="outline: none"
                                    >Criteria Ignored</label
                                >
                                <label v-else for="switch_criteria" style="outline: none"
                                    >All Criteria</label
                                >
                            </div>

                            <div class="field">
                                <input
                                    id="switch_reviewed"
                                    type="checkbox"
                                    name="switch_reviewed"
                                    class="switch is-rounded is-info"
                                    checked="checked"
                                    v-model="not_reviewed"
                                />
                                <label
                                    v-if="not_reviewed"
                                    for="switch_reviewed"
                                    style="outline: none"
                                    >Not Reviewed</label
                                >
                                <label v-else for="switch_reviewed" style="outline: none"
                                    >All Reviewed</label
                                >
                            </div>
                        </div>

                        <div class="field is-horizontal is-expanded">
                            <div class="field-label is-normal">
                                <label class="label">Customer</label>
                            </div>
                            <div class="field-body">
                                <div class="field is-expanded">
                                    <span class="select is-fullwidth">
                                        <select id="customer_select" v-model="filter_customer">
                                            <option disabled value="">Select Customer</option>
                                            <option
                                                v-for="item in customer_items"
                                                :key="'cust_' + item"
                                                :value="item"
                                            >
                                                {{ item }}
                                            </option>
                                        </select>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Part</label>
                            </div>
                            <div class="field-body">
                                <div class="field is-expanded">
                                    <input
                                        type="text"
                                        class="input"
                                        placeholder="Part (optional)"
                                        v-model="filter_part"
                                        @input="filter_part = $event.target.value.toUpperCase()"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Period</label>
                            </div>
                            <div class="field-body">
                                <div class="field has-addons">
                                    <p class="control">
                                        <span class="select">
                                            <select
                                                id="date_range"
                                                v-model="date_range"
                                                @change="change_date(date_range)"
                                            >
                                                <option
                                                    disabled
                                                    hidden
                                                    value=""
                                                    style="color: grey"
                                                >
                                                    Date Presets
                                                </option>
                                                <option value="today">Today</option>
                                                <option value="yesterday">Yesterday</option>
                                                <option value="week">Week</option>
                                                <option value="this_month">This Month</option>
                                                <option value="prev_month">Prev Month</option>
                                                <option value="this_quarter">This Quarter</option>
                                                <option value="prev_quarter">Prev Quarter</option>
                                                <option value="this_year">This Year</option>
                                                <option value="prev_year">Prev Year</option>
                                                <option value="all">All</option>
                                                <option disabled hidden value="custom">
                                                    Custom
                                                </option>
                                            </select>
                                        </span>
                                    </p>

                                    <p class="control is-expanded">
                                        <VueDatePicker
                                            v-model="range"
                                            :enable-time-picker="false"
                                            range
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="buttons is-right filters-actions">
                            <button @click="reset" class="button is-small is-white">Reset</button>
                            <div class="filter-action">
                                <button
                                    :disabled="filter_customer == '' || isSearching"
                                    @click="ajax_get_dashboard"
                                    class="button is-info"
                                >
                                    Filter
                                </button>
                                <span
                                    v-if="isSearching"
                                    class="loading-icon"
                                    aria-live="polite"
                                    aria-label="Loading pricing analysis"
                                >
                                    <i class="material-icons rotating">.</i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="dashboard_data" class="table-section" v-if="queryData.length > 0">
                <div class="title_div">
                    <span class="site">Pricing Analysis</span>
                </div>
                <p class="analysis-title">{{ analysisTitle }}</p>
                <div
                    class="buttons is-right filters-actions"
                    v-if="
                        pricingAnalysisSelectedIds.length > 0 &&
                        (is_staff || dashboard_permissions.includes('research_parts_generic'))
                    "
                >
                    <button class="button" @click="research_parts">Research Parts</button>
                    <button class="button" @click="ajax_pricing_details">Pricing Details</button>
                </div>
                <SimpleDataTable
                    ref="pricingAnalysisTable"
                    :headers="pricingAnalysisHeaders"
                    :data="pricingAnalysisTableRows"
                    row-key="part_number"
                    :default-items-per-page="vgtable_paged_default"
                    :items-per-page-options="[3, 5, 7, 10, 20, 50]"
                    @selection-changed="onPricingAnalysisSelection"
                />
                <div class="buttons is-right">
                    <button
                        class="button is-info"
                        style="margin: 0.5em 0 0 0"
                        @click="
                            $emit('download-csv', [queryData, 'PricingAnalysisDashboard', null])
                        "
                    >
                        Download CSV
                    </button>
                </div>
            </section>

            <section
                class="plot-section"
                id="plot_data_dollars"
                v-if="(sales.length > 0) | (quotes.length > 0) | (open_pos.length > 0)"
                style="margin-top: 2em"
            >
                <PlotlyFigure
                    :plot_data="plotDataDollars"
                    :layout="plot_layout_dollars"
                    :options="plot_options"
                    :key="'figdollars' + figureKeyDollars"
                >
                </PlotlyFigure>
            </section>

            <section
                id="table_pricing_action"
                class="table-section"
                v-if="pricingActionData.length > 0"
            >
                <div class="title_div">
                    <span class="site">Pricing Actions</span>
                </div>
                <div
                    class="buttons is-right filters-actions"
                    v-if="
                        pricingActionsSelectedIds.length > 0 &&
                        (is_staff || dashboard_permissions.includes('pricing_action'))
                    "
                >
                    <button class="button" @click="show_modal_pricing_action()">Approval</button>
                </div>
                <SimpleDataTable
                    ref="pricingActionsTable"
                    :headers="pricingActionsHeaders"
                    :data="pricingActionsTableRows"
                    row-key="id"
                    :default-items-per-page="vgtable_paged_default"
                    :items-per-page-options="[3, 5, 7, 10, 20, 50]"
                    @selection-changed="onPricingActionsSelection"
                    :key="pricing_action_key"
                />
                <div class="buttons is-right">
                    <button
                        class="button is-info"
                        style="margin: 0.5em 0 0 0"
                        @click="$emit('download-csv', [quotes, 'PricingAnalysis_Actions', null])"
                    >
                        Download CSV
                    </button>
                </div>
            </section>

            <section id="dashboard_detail_quotes" class="table-section" v-if="quotes.length > 0">
                <div class="title_div">
                    <span class="site">Quotes</span>
                </div>
                <SimpleDataTable
                    ref="quotesTable"
                    :headers="quotesHeaders"
                    :data="quotesTableRows"
                    row-key="quote_id"
                    :enable-selection="false"
                    :default-items-per-page="vgtable_paged_default"
                    :items-per-page-options="[3, 5, 7, 10, 20, 50]"
                />
                <div class="buttons is-right">
                    <button
                        class="button is-info"
                        style="margin: 0.5em 0 0 0"
                        @click="$emit('download-csv', [quotes, 'PricingAnalysis_Quotes', null])"
                    >
                        Download CSV
                    </button>
                </div>
            </section>

            <section id="dashboard_detail_sales" class="table-section" v-if="sales.length > 0">
                <div class="title_div">
                    <span class="site">Sales</span>
                </div>
                <SimpleDataTable
                    ref="salesTable"
                    :headers="salesHeaders"
                    :data="salesTableRows"
                    row-key="sale_id"
                    :enable-selection="false"
                    :default-items-per-page="vgtable_paged_default"
                    :items-per-page-options="[3, 5, 7, 10, 20, 50]"
                />
                <div class="buttons is-right">
                    <button
                        class="button is-info"
                        style="margin: 0.5em 0 0 0"
                        @click="$emit('download-csv', [sales, 'PricingAnalysis_Sales', null])"
                    >
                        Download CSV
                    </button>
                </div>
            </section>

            <section id="dashboard_detail_pos" class="table-section" v-if="open_sos.length > 0">
                <div class="title_div">
                    <span class="site">Open SOs</span>
                </div>
                <SimpleDataTable
                    ref="openSosTable"
                    :headers="openSosHeaders"
                    :data="openSosTableRows"
                    row-key="so_number"
                    :enable-selection="false"
                    :default-items-per-page="vgtable_paged_default"
                    :items-per-page-options="[3, 5, 7, 10, 20, 50]"
                />
                <div class="buttons is-right">
                    <button
                        class="button is-info"
                        style="margin: 0.5em 0 0 0"
                        @click="$emit('download-csv', [open_sos, 'PricingAnalysis_OpenSOs', null])"
                    >
                        Download CSV
                    </button>
                </div>
            </section>

            <section id="dashboard_detail_pos" class="table-section" v-if="open_pos.length > 0">
                <div class="title_div">
                    <span class="site">Open POs</span>
                </div>
                <SimpleDataTable
                    ref="openPosTable"
                    :headers="openPosHeaders"
                    :data="openPosTableRows"
                    row-key="po_number"
                    :enable-selection="false"
                    :default-items-per-page="vgtable_paged_default"
                    :items-per-page-options="[3, 5, 7, 10, 20, 50]"
                />
                <div class="buttons is-right">
                    <button
                        class="button is-info"
                        style="margin: 0.5em 0 0 0"
                        @click="$emit('download-csv', [open_pos, 'PricingAnalysis_OpenPOs', null])"
                    >
                        Download CSV
                    </button>
                </div>
            </section>
        </div>
    </div>
</template>

<style scoped>
    .filters-section {
        display: flex;
        justify-content: center;
    }

    .filters-card {
        width: 100%;
        max-width: 760px;
        margin: 0 auto 1.5em;
    }

    .filters-body {
        display: flex;
        flex-direction: column;
        gap: 0.75em;
    }

    .filters-actions {
        margin-top: 0.5em;
        gap: 0.75em;
    }

    .filter-action {
        display: flex;
        align-items: center;
        gap: 0.5em;
    }

    .field-row {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 0.5em;
    }

    .loading-icon {
        display: flex;
        align-items: center;
        color: #3273dc;
    }

    .rotating {
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    .title_div {
        margin-top: 1.5em;
    }

    .site {
        font-size: 2em;
    }

    .analysis-title {
        font-weight: 600;
        margin: 0.35em 0 0.85em;
    }
    .plot-section,
    .table-section {
        margin-top: 2em;
        margin-bottom: 2em;
        max-width: 80vw;
    }
</style>

<script>
    import PlotlyFigure from '@/components/shared/Plotly.vue'
    import DataFrame from 'dataframe-js'
    import moment from 'moment'
    var numeral = require('numeral')
    import VueDatePicker from '@vuepic/vue-datepicker'
    import { getDates } from '@/helpers/dates.js'
    import HeroContainer from '@/components/shared/HeroContainer.vue'
    import { useDropdownsStore } from '@/stores/dropdownsStore'
    import { mapStores, mapWritableState } from 'pinia'
    import { useUserStore } from '@/stores/userStore'
    import { useDashPricingAnalysisStore } from '@/stores/dashPricingAnalysisStore'
    import { toast } from 'vue3-toastify'
    import SimpleDataTable from '@/components/shared/SimpleDataTable.vue'

    export default {
        name: 'DashboardPricingAnalysis',
        components: {
            PlotlyFigure,
            VueDatePicker,
            HeroContainer,
            SimpleDataTable,
        },
        watch: {
            plotDataDate: function () {
                // Change key to force the component to re-render
                // otherwise it will have height=0
                this.figureKeyDate += 1
            },
            plotDataDollars: function () {
                // Change key to force the component to re-render
                // otherwise it will have height=0
                this.figureKeyDollars += 1
            },
            deep: true,
        },
        computed: {
            ...mapStores(useUserStore, useDropdownsStore, useDashPricingAnalysisStore),
            ...mapWritableState(useDashPricingAnalysisStore, {
                has_pricing_action: 'has_pricing_action',
                criteria_ignored: 'criteria_ignored',
                not_reviewed: 'not_reviewed',
                filter_customer: 'customer',
                filter_part: 'part',
                customer_searched: 'customer_searched',
                date_range: 'date_range',
                range: 'range',
                queryDataRaw: 'queryDataRaw',
                detailDataRaw: 'detailDataRaw',
                pricingActionData: 'pricingActionData',
                research_parts_list: 'research_parts_list',
            }),
            is_staff: function () {
                return this.userStore.is_staff
            },
            dashboard_permissions: function () {
                let dashboard_permissions = this.userStore.dashboard_permissions
                if (dashboard_permissions) {
                    return dashboard_permissions
                }
                return []
            },
            customer_items() {
                return this.dropdownsStore.customer
            },
            isSearching() {
                return this.searchStore.ajax_searching > 0
            },
            queryData() {
                let raw_query = [...this.queryDataRaw]
                return raw_query
            },
            quotes() {
                if (this.detailDataRaw.quotes.length > 0) {
                    return this.detailDataRaw.quotes
                } else {
                    return []
                }
            },
            sales() {
                if (this.detailDataRaw.sales.length > 0) {
                    return this.detailDataRaw.sales
                } else {
                    return []
                }
            },
            open_pos() {
                if (this.detailDataRaw.open_pos.length > 0) {
                    return this.detailDataRaw.open_pos
                } else {
                    return []
                }
            },
            open_sos() {
                if (this.detailDataRaw.open_sos.length > 0) {
                    return this.detailDataRaw.open_sos
                } else {
                    return []
                }
            },
            plotDataDollars() {
                let data = [
                    {
                        type: 'scatter',
                        name: 'Quote Margin',
                        x: [],
                        y: [],
                        mode: 'markers',
                        marker: { size: 10 },
                        opacity: 0.8,
                    },
                    {
                        type: 'scatter',
                        name: 'Sale Margin',
                        x: [],
                        y: [],
                        mode: 'markers',
                        marker: { size: 10 },
                        opacity: 0.8,
                        text: [],
                    },
                    {
                        type: 'scatter',
                        name: 'Open PO',
                        x: [],
                        y: [],
                        mode: 'markers',
                        marker: { size: 10 },
                        opacity: 0.0,
                        text: [],
                        yaxis: 'y3',
                        showlegend: false,
                    },
                    {
                        type: 'scatter',
                        name: 'Pricing Action',
                        x: [],
                        y: [],
                        mode: 'markers',
                        marker: { size: 10 },
                        opacity: 0.8,
                        text: [],
                        hovertemplate: '%{text}',
                    },
                    { type: 'line', name: 'Quote Price', x: [], y: [], opacity: 0.5, yaxis: 'y2' },
                    { type: 'line', name: 'Sale Price', x: [], y: [], opacity: 0.5, yaxis: 'y2' },
                    {
                        type: 'scatter',
                        name: 'Sug. Margin',
                        x: [],
                        y: [],
                        mode: 'markers',
                        marker: {
                            color: 'rgba(17, 157, 255, 0.0)',
                            size: 20,
                            line: {
                                color: 'rgba(31, 119, 180, 0.5)',
                                width: 2,
                            },
                        },
                        opacity: 0.8,
                    },
                ]

                if (this.quotes.length > 0) {
                    let df = new DataFrame(this.quotes).filter((row) => row.get('unit_cost') > 0)

                    data[0].x = df.toArray('time_created')
                    data[0].y = df.toArray('margin')

                    data[4].x = df.toArray('time_created')
                    data[4].y = df.toArray('quote')

                    data[6].x = df.toArray('time_created')
                    data[6].y = df.toArray('suggested_margin')
                }
                if (this.sales.length > 0) {
                    let df = new DataFrame(this.sales)
                    let qty = df.toArray('qty_ship')
                    let sale_hover_text = []
                    for (let idx in qty) {
                        sale_hover_text.push('Qty: ' + qty[idx])
                    }
                    data[1].x = df.toArray('post_date')
                    data[1].y = df.toArray('margin')

                    data[1].text = sale_hover_text

                    data[5].x = df.toArray('post_date')
                    data[5].y = df.toArray('unit_price')
                }
                if (this.open_pos.length > 0) {
                    let df = new DataFrame(this.open_pos, [
                        'entry_date',
                        'unit_cost',
                        'qty_ordered',
                        'qty_back_order',
                    ])
                    let ordered = df.toArray('qty_ordered')
                    let back_order = df.toArray('qty_back_order')
                    let po_hover_text = []
                    for (let idx in ordered) {
                        po_hover_text.push(
                            'Ordered: ' + ordered[idx] + '<br>Back Order:' + back_order[idx]
                        )
                    }
                    data[2].x = df.toArray('entry_date')
                    data[2].y = df.toArray('unit_cost')
                    data[2].text = po_hover_text
                }
                return data
            },
            plotDataDate() {
                let data = [
                    {
                        type: 'scatter',
                        name: 'Quotes',
                        x: [],
                        y: [],
                        mode: 'markers',
                        marker: { size: 10 },
                        opacity: 0.8,
                    },
                    {
                        type: 'scatter',
                        name: 'Sales',
                        x: [],
                        y: [],
                        mode: 'markers',
                        marker: { size: 10 },
                        opacity: 0.8,
                    },
                    {
                        type: 'scatter',
                        name: 'Open POs',
                        x: [],
                        y: [],
                        mode: 'markers',
                        marker: { size: 10 },
                        opacity: 0.8,
                    },
                    {
                        type: 'scatter',
                        name: 'Pricing Action',
                        x: [],
                        y: [],
                        mode: 'markers',
                        marker: { size: 10 },
                        opacity: 0.8,
                        text: [],
                        hovertemplate: '%{text}',
                    },
                ]

                if (this.quotes.length > 0) {
                    let df = new DataFrame(this.quotes, ['time_created'])
                    df = df.map((row) =>
                        row.set('time_created', row.get('time_created').split('T')[0])
                    )
                    let agg_quotes = df
                        .groupBy('time_created')
                        .aggregate((group) => group.count('time_created'))
                        .rename('aggregation', 'count')

                    data[0].x = agg_quotes.toArray('time_created')
                    data[0].y = agg_quotes.toArray('count')
                }
                if (this.sales.length > 0) {
                    let df = new DataFrame(this.sales, ['post_date'])
                    df = df.map((row) => row.set('post_date', row.get('post_date').split('T')[0]))
                    let agg_sales = df
                        .groupBy('post_date')
                        .aggregate((group) => group.count('post_date'))
                        .rename('aggregation', 'count')

                    data[1].x = agg_sales.toArray('post_date')
                    data[1].y = agg_sales.toArray('count')
                }
                if (this.open_pos.length > 0) {
                    let df = new DataFrame(this.open_pos, ['entry_date'])
                    let agg_pos = df
                        .groupBy('entry_date')
                        .aggregate((group) => group.count('entry_date'))
                        .rename('aggregation', 'count')

                    data[2].x = agg_pos.toArray('entry_date')
                    data[2].y = agg_pos.toArray('count')
                }
                if (this.pricingActionData.length > 0) {
                    let df = new DataFrame(this.pricingActionData, [
                        'time_created',
                        'pricing_action',
                        'pricing_rule',
                    ])
                    let pricing_action = df.toArray('pricing_action')
                    let pricing_rule = df.toArray('pricing_rule')
                    let hover_text = []
                    for (let idx in pricing_action) {
                        hover_text.push(pricing_action[idx] + '<br>' + pricing_rule[idx])
                    }
                    data[3].x = df.toArray('time_created')
                    data[3].y = new Array(df.count()).fill(0)
                    data[3].text = hover_text
                }
                return data
            },
            purchase_pending_rows() {
                let data = this.queryData
                let keep_rows = []
                for (let d of data) {
                    if ((d.no_purchase == false) & (d.purchased == false)) {
                        keep_rows.push(d)
                    }
                }
                return keep_rows
            },
            purchased_rows() {
                let data = this.queryData
                let keep_rows = []
                for (let d of data) {
                    if (d.purchased == true) {
                        keep_rows.push(d)
                    }
                }
                return keep_rows
            },
            no_purchase_rows() {
                let data = this.queryData
                let keep_rows = []
                for (let d of data) {
                    if (d.no_purchase == true) {
                        keep_rows.push(d)
                    }
                }
                return keep_rows
            },
            is_paged() {
                if (this.queryData.length <= this.vgtable_paged_default) {
                    return false
                } else {
                    return true
                }
            },
            is_paged_paction() {
                if (this.pricingActionData.length <= this.vgtable_paged_default) {
                    return false
                } else {
                    return true
                }
            },
            is_paged_quotes() {
                if (this.quotes.length <= this.vgtable_paged_default) {
                    return false
                } else {
                    return true
                }
            },
            is_paged_sales: function () {
                if (this.sales.length <= this.vgtable_paged_default) {
                    return false
                } else {
                    return true
                }
            },
            is_paged_open_pos: function () {
                if (this.open_pos.length <= this.vgtable_paged_default) {
                    return false
                } else {
                    return true
                }
            },
            is_paged_open_sos: function () {
                if (this.open_sos.length <= this.vgtable_paged_default) {
                    return false
                } else {
                    return true
                }
            },
            columns() {
                return [
                    {
                        label: 'Part Number',
                        field: 'part_number',
                        type: 'text',
                    },
                    {
                        label: 'Part Array',
                        field: 'part_array',
                        type: 'text',
                        formatFn: function (value) {
                            if (Array.isArray(value)) {
                                return value.join(', ')
                            }
                            return value
                        },
                    },
                    {
                        label: 'Quotes Since Sale',
                        field: 'quotes_since_sale',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0')
                        },
                    },
                    {
                        label: 'Win Percent',
                        field: 'win_percent',
                        type: 'number',
                        formatFn: function (value) {
                            if (value) {
                                return numeral(value).format('0,0,0,0,0.0%')
                            } else {
                                return value
                            }
                        },
                    },
                    {
                        label: 'Win Count',
                        field: 'win_count',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0')
                        },
                    },
                    {
                        label: 'Quote Count',
                        field: 'quote_count',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0')
                        },
                    },
                    {
                        label: 'Quote Qty',
                        field: 'quote_qty',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0')
                        },
                    },
                    {
                        label: 'Last Quote',
                        field: 'last_quote',
                        type: 'text',
                        formatFn: function (value) {
                            return moment(value).format('YYYY-MM-DD HH:mm')
                        },
                    },
                    {
                        label: 'User',
                        field: 'user',
                        type: 'text',
                    },
                    {
                        label: 'Quote Unit Cost',
                        field: 'quote_unit_cost',
                        type: 'number',
                        formatFn: function (value) {
                            if (value) {
                                return numeral(value).format('$0,0,0,0,0.00')
                            } else {
                                return value
                            }
                        },
                    },
                    {
                        label: 'Quote Unit Price',
                        field: 'quote_unit_price',
                        type: 'number',
                        formatFn: function (value) {
                            if (value) {
                                return numeral(value).format('$0,0,0,0,0.00')
                            } else {
                                return value
                            }
                        },
                    },
                    {
                        label: 'Quote Margin',
                        field: 'quote_margin',
                        type: 'number',
                        formatFn: function (value) {
                            if (value) {
                                return numeral(value).format('0,0,0,0,0.0%')
                            } else {
                                return value
                            }
                        },
                    },
                    {
                        label: 'Last Sale',
                        field: 'last_sale',
                        type: 'text',
                        formatFn: function (value) {
                            if (value) {
                                return moment(value).format('YYYY-MM-DD HH:mm')
                            } else {
                                return ''
                            }
                        },
                    },
                    {
                        label: 'Sale Unit Cost',
                        field: 'sale_unit_cost',
                        type: 'number',
                        formatFn: function (value) {
                            if (value) {
                                return numeral(value).format('$0,0,0,0,0.00')
                            } else {
                                return value
                            }
                        },
                    },
                    {
                        label: 'Sale Unit Price',
                        field: 'sale_unit_price',
                        type: 'number',
                        formatFn: function (value) {
                            if (value) {
                                return numeral(value).format('$0,0,0,0,0.00')
                            } else {
                                return value
                            }
                        },
                    },
                    {
                        label: 'Has Action',
                        field: 'has_action',
                        type: 'boolean',
                        formatFn: function (value) {
                            if (value) {
                                return value
                            } else {
                                return ''
                            }
                        },
                    },
                ]
            },
            columns_quotes() {
                return [
                    {
                        label: 'Time Created',
                        field: 'time_created',
                        type: 'text',
                        formatFn: function (value) {
                            if (value) {
                                return value.split('T')[0]
                            } else {
                                return ''
                            }
                        },
                    },
                    {
                        label: 'Part Number',
                        field: 'part_coalesce',
                        type: 'text',
                    },
                    {
                        label: 'Meets Criteria',
                        field: 'meets_criteria',
                        type: 'boolean',
                    },
                    {
                        label: 'Description',
                        field: 'description',
                        type: 'text',
                    },
                    {
                        label: 'Notes',
                        field: 'notes',
                        type: 'text',
                    },
                    {
                        label: 'Vendor',
                        field: 'vendor',
                        type: 'text',
                    },
                    {
                        label: 'Unit Cost',
                        field: 'unit_cost',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Quote',
                        field: 'quote',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Suggested Quote',
                        field: 'suggested_price',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Quantity',
                        field: 'quantity',
                        type: 'number',
                    },
                    {
                        label: 'Ext Quote',
                        field: 'ext_quote',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },

                    {
                        label: 'Margin',
                        field: 'margin',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0.00%')
                        },
                    },
                    {
                        label: 'Suggested Margin',
                        field: 'suggested_margin',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0.00%')
                        },
                    },
                    {
                        label: 'Rule',
                        field: 'rule',
                        type: 'text',
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        type: 'text',
                    },
                    {
                        label: 'Type',
                        field: 'quote_type',
                        type: 'text',
                    },
                    {
                        label: 'UOM',
                        field: 'unit_of_measure',
                        type: 'text',
                    },
                    {
                        label: 'Quote ID',
                        field: 'quote_id',
                        type: 'text',
                    },
                    {
                        label: 'SA ID',
                        field: 'search_action_id',
                        type: 'text',
                    },
                ]
            },
            columns_sales() {
                return [
                    {
                        label: 'Post Date',
                        field: 'post_date',
                        type: 'text',
                        formatFn: function (value) {
                            return value.split('T')[0]
                        },
                    },
                    {
                        label: 'Part',
                        field: 'part_number',
                        type: 'text',
                    },
                    {
                        label: 'Description',
                        field: 'description',
                        type: 'text',
                    },
                    {
                        label: 'Invoice',
                        field: 'invoice',
                        type: 'text',
                    },
                    {
                        label: 'Margin',
                        field: 'margin',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0.00%')
                        },
                    },
                    {
                        label: 'Company PO',
                        field: 'company_po_number',
                        type: 'text',
                    },
                    {
                        label: 'Profit',
                        field: 'profit',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Unit Cost',
                        field: 'unit_cost',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Unit Price',
                        field: 'unit_price',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Total Cost',
                        field: 'total_cost',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Total Price',
                        field: 'total_price',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Bill Name',
                        field: 'bill_name',
                        type: 'text',
                    },
                    {
                        label: 'Vendor',
                        field: 'vendor_name',
                        type: 'text',
                    },
                    {
                        label: 'Dept Name',
                        field: 'dept_name',
                        type: 'text',
                    },
                    {
                        label: 'Orig PO',
                        field: 'original_po_number',
                        type: 'text',
                    },
                    {
                        label: 'Qty Invoiced',
                        field: 'qty_invoiced',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0')
                        },
                    },
                    {
                        label: 'Reference',
                        field: 'reference',
                        type: 'text',
                    },
                    {
                        label: 'Invoice Date',
                        field: 'invoice_date',
                        type: 'text',
                        formatFn: function (value) {
                            return value.split('T')[0]
                        },
                    },
                    {
                        label: 'Sale ID',
                        field: 'sale_id',
                        type: 'text',
                    },
                ]
            },
            columns_sos() {
                return [
                    {
                        label: 'Entry Date',
                        field: 'entry_date',
                        type: 'text',
                    },
                    {
                        label: 'Part',
                        field: 'part_number',
                        type: 'text',
                    },
                    {
                        label: 'Description',
                        field: 'description',
                        type: 'text',
                    },
                    {
                        label: 'Bill Name',
                        field: 'bill_name',
                        type: 'text',
                    },
                    {
                        label: 'Next Delivery',
                        field: 'next_delivery_date',
                        type: 'text',
                    },

                    {
                        label: 'Unit Cost',
                        field: 'unit_cost',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Total Cost',
                        field: 'total_cost',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Qty Ordered',
                        field: 'po_qty_ordered',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0')
                        },
                    },
                    {
                        label: 'Qty Back Order',
                        field: 'qty_bo',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0')
                        },
                    },
                    {
                        label: 'Qty Rec',
                        field: 'qty_rec',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0')
                        },
                    },
                    {
                        label: 'Vendor',
                        field: 'vendor_name',
                        type: 'text',
                    },
                    {
                        label: 'SO Number',
                        field: 'so_number',
                        type: 'text',
                    },
                    {
                        label: 'Dept Name',
                        field: 'dept_name',
                        type: 'text',
                    },
                ]
            },
            columns_pos() {
                return [
                    {
                        label: 'Entry Date',
                        field: 'entry_date',
                        type: 'text',
                    },
                    {
                        label: 'Part',
                        field: 'part_number',
                        type: 'text',
                    },
                    {
                        label: 'Description',
                        field: 'description',
                        type: 'text',
                    },
                    {
                        label: 'Next Delivery',
                        field: 'next_delivery_date',
                        type: 'text',
                    },

                    {
                        label: 'Unit Cost',
                        field: 'unit_cost',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Total Cost',
                        field: 'total_cost',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Qty Ordered',
                        field: 'qty_ordered',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0')
                        },
                    },
                    {
                        label: 'Qty Back Order',
                        field: 'qty_back_order',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0')
                        },
                    },
                    {
                        label: 'Vendor',
                        field: 'vendor_name',
                        type: 'text',
                    },
                    {
                        label: 'PO Number',
                        field: 'po_number',
                        type: 'text',
                    },
                    {
                        label: 'Dept Name',
                        field: 'dept_name',
                        type: 'text',
                    },

                    {
                        label: 'Poso Qty',
                        field: 'poso_qty',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0')
                        },
                    },
                    {
                        label: 'Poso Qty Rec',
                        field: 'poso_qtyrec',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0')
                        },
                    },
                ]
            },
            columns_pricing_actions() {
                return [
                    {
                        label: 'Time Created',
                        field: 'time_created',
                        type: 'text',
                        formatFn: function (value) {
                            return value.split('T')[0]
                        },
                    },
                    {
                        label: 'Part',
                        field: 'part_number',
                        type: 'text',
                    },
                    {
                        label: 'User',
                        field: 'user',
                        type: 'text',
                    },
                    {
                        label: 'Meets Criteria',
                        field: 'meets_criteria',
                        type: 'boolean',
                    },
                    {
                        label: 'Rule',
                        field: 'rule',
                        type: 'text',
                    },
                    {
                        label: 'Version',
                        field: 'version',
                        type: 'text',
                    },
                    {
                        label: 'Description',
                        field: 'description',
                        type: 'text',
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        type: 'text',
                    },
                    {
                        label: 'List Price',
                        field: 'list_price',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Quote Initial',
                        field: 'quote_initial',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Quote Final',
                        field: 'quote_final',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Sug. Quote',
                        field: 'suggested_price',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('$0,0,0,0,0.00')
                        },
                    },
                    {
                        label: 'Quote Margin',
                        field: 'user_margin',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0.0') + '%'
                        },
                    },
                    {
                        label: 'Sug. Margin',
                        field: 'suggested_margin',
                        type: 'number',
                        formatFn: function (value) {
                            return numeral(value).format('0,0,0,0,0.0%')
                        },
                    },
                    {
                        label: 'User Reason',
                        field: 'user_reason',
                        type: 'text',
                    },
                    {
                        label: 'Approval',
                        field: 'approval',
                        type: 'boolean',
                    },
                    {
                        label: 'Approval Note',
                        field: 'approval_note',
                        type: 'text',
                    },
                    {
                        label: 'Time Updated',
                        field: 'time_updated',
                        type: 'text',
                        formatFn: function (value) {
                            return value.split('T')[0]
                        },
                    },
                    {
                        label: 'PA ID',
                        field: 'id',
                        type: 'text',
                    },
                    {
                        label: 'Quote ID',
                        field: 'quote_id',
                        type: 'text',
                    },
                ]
            },
            plot_shapes() {
                let shapes = []

                for (let po of this.open_pos) {
                    let date = po.entry_date
                    let line = {
                        type: 'line',
                        xref: 'x',
                        yref: 'paper',
                        x0: date,
                        x1: date,
                        y0: 0,
                        y1: 1,
                        line: {
                            color: 'rgb(44, 160, 44)',
                            width: 2,
                        },
                    }
                    shapes.push(line)
                }
                // Add one vertical line for today's date
                let date = moment().toISOString().split('T')[0]
                let line = {
                    type: 'line',
                    xref: 'x',
                    yref: 'paper',
                    x0: date,
                    x1: date,
                    y0: 0,
                    y1: 1,
                    line: {
                        color: 'rgb(220,220,220)',
                        width: 1,
                        dash: 'dot',
                    },
                }
                shapes.push(line)
                return shapes
            },
            plot_layout_date: function () {
                return {
                    legend: {
                        x: 0,
                        y: 1.5,
                    },
                    yaxis: {
                        title: {
                            text: 'Pricing Dates',
                            font: {
                                size: 18,
                            },
                        },
                        rangemode: 'tozero',
                    },
                    shapes: this.plot_shapes,
                }
            },
            plot_layout_dollars: function () {
                return {
                    legend: {
                        x: 0,
                        y: 1.5,
                    },
                    xaxis: {},
                    yaxis: {
                        title: {
                            text: 'Replacement Margin',
                            font: {
                                size: 18,
                            },
                        },
                        autorange: true,
                        tickformat: ',.1%',
                    },
                    yaxis2: {
                        title: {
                            text: 'Price',
                            font: {
                                size: 18,
                            },
                        },
                        overlaying: 'y',
                        side: 'right',
                        tickformat: '$,.2f',
                    },
                    yaxis3: {
                        title: {
                            text: 'Price',
                            font: {
                                size: 18,
                            },
                        },
                        overlaying: 'y',
                        side: 'right',
                        tickformat: '$,.0f',
                        visible: false,
                    },
                    shapes: this.plot_shapes,
                }
            },
            pricingAnalysisHeaders() {
                return this.columns.map((column) => ({
                    key: column.field,
                    label: column.label,
                    formatter: column.formatFn,
                }))
            },
            pricingActionsHeaders() {
                return this.columns_pricing_actions.map((column) => ({
                    key: column.field,
                    label: column.label,
                    formatter: column.formatFn,
                }))
            },
            quotesHeaders() {
                return this.columns_quotes.map((column) => ({
                    key: column.field,
                    label: column.label,
                    formatter: column.formatFn,
                }))
            },
            salesHeaders() {
                return this.columns_sales.map((column) => ({
                    key: column.field,
                    label: column.label,
                    formatter: column.formatFn,
                }))
            },
            openSosHeaders() {
                return this.columns_sos.map((column) => ({
                    key: column.field,
                    label: column.label,
                    formatter: column.formatFn,
                }))
            },
            openPosHeaders() {
                return this.columns_pos.map((column) => ({
                    key: column.field,
                    label: column.label,
                    formatter: column.formatFn,
                }))
            },
            pricingAnalysisTableRows() {
                return this.formatTableRows(
                    this.queryData,
                    this.pricingAnalysisHeaders,
                    'part_number'
                )
            },
            pricingActionsTableRows() {
                return this.formatTableRows(this.pricingActionData, this.pricingActionsHeaders)
            },
            quotesTableRows() {
                return this.formatTableRows(this.quotes, this.quotesHeaders, 'quote_id')
            },
            salesTableRows() {
                return this.formatTableRows(this.sales, this.salesHeaders, 'sale_id')
            },
            openSosTableRows() {
                return this.formatTableRows(this.open_sos, this.openSosHeaders, 'so_number')
            },
            openPosTableRows() {
                return this.formatTableRows(this.open_pos, this.openPosHeaders, 'po_number')
            },
            analysisTitle() {
                const customerLabel = this.filter_customer || 'All Customers'
                let periodLabel = 'All Dates'
                if (Array.isArray(this.range) && this.range.length === 2) {
                    const [start, end] = this.range
                    if (start && end) {
                        periodLabel = `${moment(start).format('YYYY-MM-DD')} to ${moment(
                            end
                        ).format('YYYY-MM-DD')}`
                    }
                }
                return `Analysis for Customer ${customerLabel} from the period ${periodLabel}`
            },
        },
        data: function () {
            return {
                vgtable_paged_default: 5,
                pa_id: '',
                pa_part_number: '',
                pa_customer: '',
                pa_approval: '',
                pa_approval_note: '',
                pa_user_quote: '',
                pa_user_margin: '',
                pa_suggested_quote: '',
                pa_suggested_margin: '',
                pa_description: '',
                pricing_action_key: 'pa_0',
                figureKeyDate: 0,
                figureKeyDollars: 0,
                plot_options: {
                    displayModeBar: false,
                    responsive: true,
                },
                pricingAnalysisSelectedIds: [],
                pricingActionsSelectedIds: [],
            }
        },
        methods: {
            getDates,
            formatValue(value, formatter) {
                if (typeof formatter === 'function') {
                    return formatter(value)
                }
                return value ?? ''
            },
            formatTableRows(rows = [], headers = [], fallbackKey = 'id') {
                return rows.map((row, index) => {
                    const formatted = {}
                    headers.forEach((header) => {
                        formatted[header.key] = this.formatValue(row[header.key], header.formatter)
                    })
                    const keyValue = row?.id ?? row?.[fallbackKey] ?? index
                    return { ...row, ...formatted, id: keyValue }
                })
            },
            onPricingAnalysisSelection(ids) {
                this.pricingAnalysisSelectedIds = ids
            },
            onPricingActionsSelection(ids) {
                this.pricingActionsSelectedIds = ids
            },
            clearTableSelection(refName) {
                const tableRef = this.$refs[refName]
                if (tableRef && typeof tableRef.clearSelection === 'function') {
                    tableRef.clearSelection()
                }
            },
            getSelectedRows(ids = [], source = [], key = 'id') {
                const idSet = new Set(ids)
                return source.filter((row) => idSet.has(row?.[key] ?? row?.id))
            },

            reset() {
                this.dashPricingAnalysisStore.resetDashPricingAnalysis()
            },
            resetTablesCharts() {
                this.queryDataRaw = []
                this.pricingActionData = []
                this.dashPricingAnalysisStore.resetDetailData()
                this.research_parts_list = []
                this.customer_searched = ''
                this.pricingAnalysisSelectedIds = []
                this.pricingActionsSelectedIds = []
                this.clearTableSelection('pricingAnalysisTable')
                this.clearTableSelection('pricingActionsTable')
            },
            resetPaModalData() {
                this.pa_id = ''
                this.pa_part_number = ''
                this.pa_customer = ''
                this.pa_approval = ''
                this.pa_approval_note = ''
                this.pa_user_quote = ''
                this.pa_user_margin = ''
                this.pa_suggested_quote = ''
                this.pa_suggested_margin = ''
                this.pa_description = ''
            },
            show_modal_pricing_action() {
                const selectedRows = this.getSelectedRows(
                    this.pricingActionsSelectedIds,
                    this.pricingActionData
                )

                if (selectedRows.length > 1) {
                    alert('Please select only 1 row')
                    this.resetPaModalData()
                    return
                }

                const data = selectedRows[0]
                if (!data) {
                    alert('Please select 1 row')
                    return
                }

                // Add data to the modal form
                this.pa_id = data.id
                this.pa_approval = data.approval
                this.pa_approval_note = data.approval_note
                this.pa_user_quote = data.quote_final
                this.pa_user_margin = numeral(data.user_margin).format('0,0,0,0,0.0') + '%'
                this.pa_suggested_quote = data.suggested_price
                this.pa_suggested_margin = numeral(data.suggested_margin).format('0,0,0,0,0.0%')
                this.pa_description = data.description

                //Set common fields
                this.pa_part_number = data.part_number
                this.pa_customer = this.filter_customer

                // Show modal form
                document.getElementById('modal_pricing_action').classList.add('is-active')
            },
            close_modal_pricing_action() {
                this.resetPaModalData()
                this.pricingActionsSelectedIds = []
                this.pricingAnalysisSelectedIds = []
                this.clearTableSelection('pricingActionsTable')
                this.clearTableSelection('pricingAnalysisTable')
                document.getElementById('modal_pricing_action').classList.remove('is-active')
            },
            modal_pricing_action_approval_change(approval) {
                this.pa_approval = approval
                this.approve_pricing_action()
            },
            async approve_pricing_action() {
                const pricing_action = {
                    id: this.pa_id,
                    part_number: this.pa_part_number,
                    customer: this.pa_customer,
                    approval: this.pa_approval,
                    approval_note: this.pa_approval_note,
                }
                this.close_modal_pricing_action()
                this.set_searching(true)
                try {
                    const updated =
                        await this.dashPricingAnalysisStore.approvePricingAction(pricing_action)
                    if (updated) {
                        const key = this.pricing_action_key.split('_')
                        const index = parseInt(key[1] || '0')
                        this.pricing_action_key = key[0] + '_' + (isNaN(index) ? 0 : index + 1)
                    }
                } catch (error) {
                    console.error('Failed to approve pricing action', error)
                    alert('ERROR: Failed to create pricing action')
                } finally {
                    this.set_searching(false)
                }
            },
            research_parts() {
                const selectedRows = this.getSelectedRows(
                    this.pricingAnalysisSelectedIds,
                    this.queryData,
                    'part_number'
                )
                const parts_list = selectedRows.map((row) => row.part_number)
                this.research_parts_list = parts_list
                const partsQuery = parts_list.join(',')
                // Route to dashboard so DashboardBase handles the query search
                this.$router.push({
                    name: 'dashboard',
                    query: { part: partsQuery },
                })
            },
            change_date(date_range) {
                let range = this.getDates(date_range)
                if (range) {
                    this.range = range
                }
            },
            set_searching(is_searching) {
                this.searchStore.set_ajax_searching(is_searching)
            },
            showToast(message, type = 'default') {
                toast(message, {
                    type,
                    pauseOnFocusLoss: false,
                })
            },
            async ajax_get_dashboard() {
                this.resetTablesCharts()
                const time_created_begin = moment.utc(this.range[0]).format('YYYY-MM-DD')
                const time_created_end = moment
                    .utc(this.range[1])
                    .add(1, 'day')
                    .format('YYYY-MM-DD')
                this.set_searching(true)
                try {
                    await this.dashPricingAnalysisStore.fetchDashboardPricingAnalysis({
                        time_created_begin: time_created_begin,
                        time_created_end: time_created_end,
                        customer: this.filter_customer,
                        part_number: this.filter_part,
                        has_pricing_action: this.has_pricing_action,
                        criteria_ignored: this.criteria_ignored,
                        not_reviewed: this.not_reviewed,
                    })
                } catch (error) {
                    console.error('Failed to load pricing analysis dashboard', error)
                } finally {
                    this.set_searching(false)
                }
            },
            async ajax_pricing_details() {
                const rows = this.getSelectedRows(
                    this.pricingAnalysisSelectedIds,
                    this.queryData,
                    'part_number'
                )
                if (rows.length > 1) {
                    alert('Please select only 1 row')
                    return
                }
                this.set_searching(true)
                const part_number_list = []
                for (let row of rows) {
                    part_number_list.push(row.part_number)
                }
                this.research_parts_list = part_number_list
                try {
                    await this.dashPricingAnalysisStore.fetchPricingDetails({
                        part_number_list: part_number_list,
                        customer: this.filter_customer,
                    })
                    this.pricingAnalysisSelectedIds = []
                    this.clearTableSelection('pricingAnalysisTable')
                    this.showToast(`Loaded: ${part_number_list.length} part details`, 'success')
                } catch (error) {
                    console.error('Failed to load pricing details', error)
                } finally {
                    this.set_searching(false)
                }
            },
            async ajax_purchase_update(table_ref, purchased = null, no_purchase = null) {
                this.set_searching(true)
                const isPricingActions = table_ref === 'pricingActionsTable'
                const selectionIds = isPricingActions
                    ? this.pricingActionsSelectedIds
                    : this.pricingAnalysisSelectedIds
                const sourceData = isPricingActions ? this.pricingActionData : this.queryData
                const key = isPricingActions ? 'id' : 'part_number'
                const rows = this.getSelectedRows(selectionIds, sourceData, key)
                const ids = rows.map((row) => row.id)
                try {
                    await this.dashPricingAnalysisStore.updatePurchaseResearch({
                        id_list: ids,
                        purchased: purchased,
                        no_purchase: no_purchase,
                    })
                } catch (error) {
                    console.error('Failed to update purchase research', error)
                } finally {
                    this.set_searching(false)
                }
            },
        },
    }
</script>
